import React from 'react';
import {
    StyledTopBar,
    StyledTopBarContainer,
    TopBarMain,
    TopBarVisuallyLeft,
    TopBarVisuallyRight,
} from './TopBar.styles';
import ProgramInfo from './ProgramInfo';
import BackButton from '../BackButton';
import EpisodePickerButton from '../EpisodePickerButton';

const TopBar = ({
    title,
    episodeTitle,
    noGradient = false,
    url,
    videos,
    selectedVideoId,
    updateAccessibilityVersion,
    parentUrl,
    setDisplayEpisodePicker,
    displayEpisodePicker,
    showEpisodePickerButton,
    playedPercentage,
}) => (
    <StyledTopBarContainer noGradient={noGradient}>
        <StyledTopBar justifyEnd={displayEpisodePicker}>
            {displayEpisodePicker ? (
                <>
                    <TopBarVisuallyLeft />
                    <TopBarMain />
                </>
            ) : (
                <>
                    <TopBarVisuallyLeft>
                        <BackButton>Tillbaka</BackButton>
                    </TopBarVisuallyLeft>
                    <TopBarMain>
                        <ProgramInfo
                            title={title}
                            episodeTitle={episodeTitle}
                            url={url}
                            videos={videos}
                            selectedVideoId={selectedVideoId}
                            updateAccessibilityVersion={updateAccessibilityVersion}
                            parentUrl={parentUrl}
                        />
                    </TopBarMain>
                </>
            )}
            {showEpisodePickerButton && (
                <TopBarVisuallyRight displayEpisodePicker={displayEpisodePicker}>
                    <EpisodePickerButton
                        setDisplayEpisodePicker={setDisplayEpisodePicker}
                        displayEpisodePicker={displayEpisodePicker}
                        playedPercentage={playedPercentage}
                    />
                </TopBarVisuallyRight>
            )}
        </StyledTopBar>
    </StyledTopBarContainer>
);

export default TopBar;
